import API from "axios";

import Axios from "../Config/API";
import Service from "../Service";

interface IViaCepValid {
    cep: string;
    logradouro: string;
    complemento: string;
    bairro: string;
    localidade: string;
    uf: string;
    ibge: number;
    gia: string;
    ddd: number;
    siafi: number;
}
interface IError {
    data: {
        Title: string;
        title: string;
        ErroFormal: string;
        ErroInformal: string;
        erroFormal: string;
        erroInformal: string;
    };
    status: number;
}

export async function BuscaCEP(NR_CEP: number) {
    const response = await API.request<IViaCepValid>({
        method: "get",
        url: `https://viacep.com.br/ws/${NR_CEP.toString().padStart(8, '0')}/json/`,
    })
        .then((response) => {
            if (response.data && response.data.cep) return response.data;
            else {
                throw new Error("Cep Não Encontrado");
            }
        })
        .catch(() => {
            const error: IError = {
                data: {
                    title: "Não Conseguimos encontrar o CEP Informado",
                    Title: "",
                    ErroFormal: "CEP invalido",
                    ErroInformal: "Não Conseguimos encontrar o CEP Informado",
                    erroFormal: "",
                    erroInformal: "",
                },
                status: 201,
            };
            throw error;
        });
    return response;
}

export async function ListarEstados() {
    return Service(Axios.get(`/api/v1/home/estados/listarestados`));
}
